module.exports = __webpack_public_path__ + "media/images/flags/gu-22f2f241aa6f3ec0d336fd150146ae34.svg";